import React from 'react';
import { motion } from 'framer-motion';
const faqs = [{
  question: '¿Compran billetes rotos?',
  answer: 'Sí.'
}, {
  question: '¿Compran billetes escritos?',
  answer: 'Sí.'
}, {
  question: '¿Compran billetes manchados?',
  answer: 'Sí.'
}, {
  question: '¿Compran todas las denominaciones?',
  answer: 'Sí.'
}, {
  question: '¿Cómo cotizan?',
  answer: 'Primero revisamos fotografías y luego informamos el valor ofrecido.'
}, {
  question: '¿La cotización puede cambiar?',
  answer: 'Sí. Depende del estado del billete.'
}];
export function FAQ() {
  return <section className="py-24 bg-slate-50 border-t border-slate-200" data-id="element-35">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-36">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-37">
          {/* Left Column: Image */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="order-2 lg:order-1" data-id="element-38">
            <img src="https://cdn.magicpatterns.com/uploads/r7HX2GrWoyVMEidEqSEHjE/WhatsApp_Image_2026-06-30_at_02.48.55.jpg" alt="Preguntas Frecuentes FG Divisas" className="w-full rounded-3xl shadow-xl" data-id="element-39" />
          </motion.div>

          {/* Right Column: FAQ List */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="order-1 lg:order-2" data-id="element-40">
            <h2 className="text-3xl md:text-4xl font-bold text-[#0a2540] mb-8 uppercase tracking-tight" data-id="element-41">
              Preguntas Frecuentes
            </h2>
            <div className="space-y-6" data-id="element-42">
              {faqs.map((faq, index) => <div key={index} className="border-b border-slate-200 pb-4" data-id="element-43">
                  <h3 className="text-lg font-bold text-[#0a2540] mb-1" data-id="element-44">
                    {faq.question}
                  </h3>
                  <p className="text-slate-600 font-medium" data-id="element-45">{faq.answer}</p>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}